import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { RoutePath } from '@quizzach/interfaces';
import { FooterBlock } from '@quizzach/styles';
import {
	IcArrowRight,
	IcFacebook,
	IcInstagram,
	LogoWordmark,
} from '@quizzach/assets';

const Footer = () => {
	const { t } = useTranslation();

	const rows = [
		{
			label: t('footerLinks.aboutUs'),
			desc: t('footerLinks.aboutDesc'),
			to: RoutePath.AboutUs,
		},
		{
			label: t('footerLinks.faq'),
			desc: t('footerLinks.faqDesc'),
			to: RoutePath.Faq,
		},
		{
			label: t('info.contact'),
			desc: 'team@quizzach.com',
			href: 'mailto:team@quizzach.com',
		},
	];

	const legal = [
		{ label: t('footerLinks.termsOfUse'), to: RoutePath.TermsOfUse },
		{ label: t('footerLinks.cookiePolicy'), to: RoutePath.CookiePolicy },
		{ label: t('footerLinks.privacyPolicy'), to: RoutePath.PrivacyPolicy },
		{
			label: t('footerLinks.paymentSecurity'),
			to: RoutePath.PaymentProviderSecurity,
		},
		{
			label: t('footerLinks.refundPolicy'),
			// full page load on purpose: the static terms page honours the anchor,
			// the SPA route scrolls to top
			href: `${RoutePath.TermsOfUse}#refund-policy`,
		},
		{
			label: t('footerLinks.withdrawal'),
			href: 'https://quizzach.com/uploads/obrazac_za_jednostrani_raskid.pdf',
		},
	];

	return (
		<FooterBlock>
			<div className='rows'>
				{rows.map((row, index) => {
					const inner = (
						<>
							<span className='num'>{String(index + 1).padStart(2, '0')}</span>
							<h3>{row.label}</h3>
							<span className='desc'>{row.desc}</span>
							<span className='arr'>
								<IcArrowRight size={16} />
							</span>
						</>
					);

					return row.to ? (
						<Link className='row' key={row.label} to={row.to}>
							{inner}
						</Link>
					) : (
						<a className='row' key={row.label} href={row.href}>
							{inner}
						</a>
					);
				})}
			</div>

			<div className='legal'>
				{legal.map((link, index) => (
					<span key={link.label}>
						{index > 0 && <i aria-hidden='true'>·</i>}
						{link.to ? (
							<Link to={link.to}>{link.label}</Link>
						) : (
							<a href={link.href} target='_blank' rel='noopener noreferrer'>
								{link.label}
							</a>
						)}
					</span>
				))}
			</div>

			<div className='strip'>
				<div className='brand'>
					<LogoWordmark width={98} height={30} />
					<span className='copy'>© {new Date().getFullYear()}</span>
				</div>
				<span className='hand'>{t('footerLinks.seeYou')}</span>
				<div className='socials'>
					<a
						href='https://www.facebook.com/quizzach'
						target='_blank'
						rel='noreferrer'
						aria-label='Facebook'
					>
						<IcFacebook />
					</a>
					<a
						href='https://www.instagram.com/quizzach'
						target='_blank'
						rel='noreferrer'
						aria-label='Instagram'
					>
						<IcInstagram />
					</a>
					<span className='copy'>© {new Date().getFullYear()}</span>
				</div>
			</div>
		</FooterBlock>
	);
};

// Footer mounts on the homepage only (founder call, 2026-07-23); elsewhere
// info/contact/legal stay reachable via the mobile »više« sheet and the
// info centar links.
export const GlobalFooter = () => {
	const { pathname } = useLocation();

	if (pathname !== '/') return null;

	return <Footer />;
};
